import React from "react";
import { useHandleSubmit } from "../hooks/useHandleSubmit.js";

const SellPage = () => {
  const [
    price,
    description,
    priceError,
    handleSubmit,
    setPrice,
    setDescription,
  ] = useHandleSubmit();

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            Price:
            <input
              type="text"
              onChange={(e) => setPrice(e.target.value)}
              value={price}
            />
          </label>
        </div>
        {priceError && (
          <div>
            <p style={{ color: "red" }}>{priceError}</p>
          </div>
        )}
        <div>
          <label>
            Description
            <input
              type="text"
              onChange={(e) => setDescription(e.target.value)}
              value={description}
            />
          </label>
        </div>
        <button>出品する</button>
      </form>
    </div>
  );
};

export default SellPage;
